import { useEffect, useState } from "react";
import { RoomModerationInfoCollection } from "@lifeat/shared/data-models/Rooms/RoomModerationTypes";
import { useDatabaseContext } from "@contexts/DatabaseContext";

export default function useRoomInteractingBlockedListener(userId: string, roomId: string): boolean {
    const db = useDatabaseContext();

    const [isInteractingBlocked, setIsInteractingBlocked] = useState(false);
    useEffect(() => {
        if (userId && roomId) {
            const node = RoomModerationInfoCollection.at(roomId)
                .at("reportedUsers")
                .at(userId)
                .at("isInteractingBlocked").node;
            const unsub = db.subscribe(node, "value", (data) => {
                if (data.success) {
                    setIsInteractingBlocked(data.value ?? false);
                } else {
                    setIsInteractingBlocked(false);
                }
            });

            return () => unsub();
        }
        return undefined;
    }, [userId, roomId]);

    return isInteractingBlocked;
}
